    import gql from 'graphql-tag'

export const GET_ALL_CUSTOMERS = gql`
query {
  Customers: Customers{
    id
    name
    type
    mobile
    email
    profileImage
    createdFrom
    status
    label
    created_at
    updated_at
  }
}`
    export const GET_CUSTOMER_TYPES = gql`
  query customerTypes{
    customerTypes: CustomerTypes{
      id
      type
      colorCode
    }
  }
`
export const SEARCH_CUSTOMER = gql`
query searchCustomer($search: String){
  customers: Customers(where: {name: {_ilike: $search}}) {
    id
    name
  }
}`

export const SEARCH_CUSTOMER_RETURNING_EXTRA_DETAIL = gql`
query searchCustomer($search: String){
  customers: Customers(where:{_or:[{name: {_ilike: $search}},{mobile: {_ilike: $search}}]}){
    id
    name
    mobile
    profileImage
  }
}`

export const GET_CUSTOMER_BY_ID = gql`
query ($id: uuid!){
  customer: Customers(where: { id: {_eq: $id}}){
    id
    name
    type
    mobile
    email 
    createdFrom
    defaultWarehouseId
    city
    status
    companyName
    gstNumber
    typeId 
    salesExecutiveId
    CustomerCreditDetail {id customerId creditLimit outstanding availableCredit dueDayLimit createdBy updatedBy}
  }
}`

export const GET_RESERVED_STOCK_CUSTOMERS = gql`
query reserved_stock_customers($statement: String = "", $aggregate: String = "") {
  customers: custom_statement_customers(args: {statement: $statement, aggregate: $aggregate}) {
    id
    name
    mobile
    email
    profileImage
    label
    city
    aggregate
  }
}
`